import React from "react";
import { Link } from "react-router-dom";

export default function Sentinel22({ compact = false }) {
  return (
    <section
      data-testid="sentinel-22"
      className="relative grain bg-[#0A1128] text-white overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8 md:gap-16">
          <div className="col-span-12 md:col-span-4">
            <div className="flex items-center gap-3">
              <span className="brand-rule" />
              <span className="overline !text-amber-500">The Sentinel 22</span>
            </div>

            {/* Large numeric mark */}
            <div className="mt-10 relative inline-block">
              <span
                aria-hidden
                className="font-display font-black text-[180px] md:text-[240px] leading-[0.85] tracking-tighter text-amber-500 select-none"
              >
                22
              </span>
              <span className="absolute -top-2 right-2 md:right-4 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-400">
                stand watch
              </span>
            </div>
          </div>

          <div className="col-span-12 md:col-span-8 md:pt-6">
            <h2 className="font-display font-black text-3xl md:text-5xl tracking-tight leading-[1.05]">
              The "22" in our mark is not decoration.
              <br />
              <span className="text-amber-500">It is remembrance.</span>
            </h2>

            <p className="mt-8 text-slate-300 text-base md:text-lg leading-relaxed max-w-2xl">
              The number represents lives lost to suicide — particularly within our
              veteran community. It is not employed for emotional leverage. It is a
              reminder of urgency and humility.
            </p>

            <blockquote className="mt-8 border-l-2 border-amber-500 pl-6 max-w-2xl">
              <p className="font-display text-lg md:text-xl leading-snug text-white">
                "The Coalition does not claim to resolve trauma. It stands watch in
                disciplined presence. Remembrance demands restraint."
              </p>
              <footer className="mt-3 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-400">
                Institutional Bible · Vol. I
              </footer>
            </blockquote>

            {!compact && (
              <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl">
                {[
                  { k: "Urgency", v: "Why the work cannot wait." },
                  { k: "Humility", v: "Why we do not over-promise." },
                  { k: "Watchfulness", v: "Why we stand, quietly, every day." },
                ].map((p) => (
                  <div key={p.k} className="border-t border-white/15 pt-4">
                    <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-amber-500">
                      {p.k}
                    </div>
                    <p className="mt-2 text-slate-300 text-sm leading-relaxed">{p.v}</p>
                  </div>
                ))}
              </div>
            )}

            {!compact && (
              <Link
                to="/contact"
                data-testid="sentinel-22-cta"
                className="mt-12 inline-flex items-center gap-3 border border-white/30 hover:border-amber-500 hover:text-amber-500 px-6 py-4 font-semibold text-sm transition-colors"
              >
                Stand watch with us
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
